export enum ClientPaymentTerms
{
    Prepayment = 1,
    Credit = 2
}
(ClientPaymentTerms as any).__typeName = 'ClientPaymentTerms';